export const LoadingStatuses = {
  idle: "idle",
  inProgress: "inProgress",
  success: "success",
  failed: "failed",
};
